"use client";

export const BASE_URL = "https://www.innerbalance.com";

// Absolute upstream URL on both server and client. The client-side fetch
// wrapper falls back to a same-origin `/api/v1/*` proxy (handled by
// `vercel.json` routes + transforms at Vercel's edge layer) only when
// a Vercel DDoS challenge is detected.
// See `useFetchBase` for the fast-path/fallback logic (Linear #2568).
export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const AUTH_ME_URL = API_URL + "/v1/auth/me";
export const AUTH_LOGOUT_URL = API_URL + "/v1/auth/logout";
export const EVENTS_URL = API_URL + "/v1/events";
export const WITH_PERSONA_ENV_ID = process.env.NEXT_PUBLIC_WITH_PERSONA_ENV_ID;

export const CHARGEBEE_JS_URL = process.env.NEXT_PUBLIC_CHARGEBEE_JS_URL;
export const PERSONA_TEMPLATE = process.env.NEXT_PUBLIC_PERSONA_TEMPLATE;

export const VERCEL_DEPLOYMENT_ID = process.env.NEXT_PUBLIC_VERCEL_DEPLOYMENT_ID;
export const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION;

export const GOOGLE_PAY_JS_URL = "https://pay.google.com/gp/p/js/pay.js";